<div *ngIf="isSpinner">
  <div id="global-loader">
      <img src="../../assets/img/loaders/loader.svg" alt="loader">
  </div>
</div>
<router-outlet>
  <!-- <app-loader></app-loader> -->
</router-outlet>